// extracted by mini-css-extract-plugin
export default {"root":"InputLabel_root__TWlSm","rootError":"InputLabel_rootError__YS-ni","asterisk":"InputLabel_asterisk__pcpd7"};